export default __webpack_public_path__ + "48f2efaa42dd02a72894359ca3528060.js";